import "../style/notifications/Notifications.css";
import NotificationBar from "../components/sidebar/NotificationBar";
import { Box, Button, CircularProgress, Tooltip } from "@mui/material";
import { DynamicTitle } from "../utils/DynamicTitle";
import { useState, useEffect, useCallback } from "react";
import WrapperStyle from "../utils/WrapperStyle";
import { useCookies } from "react-cookie";
import axios from "../api/axios";
import Errors from "../utils/Errors";
import NotificationsOutlinedIcon from "@mui/icons-material/NotificationsOutlined";
import CampaignOutlinedIcon from "@mui/icons-material/CampaignOutlined";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import WarningAmberOutlinedIcon from "@mui/icons-material/WarningAmberOutlined";
import ErrorOutlineOutlinedIcon from "@mui/icons-material/ErrorOutlineOutlined";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import RadioButtonUncheckedIcon from "@mui/icons-material/RadioButtonUnchecked";
import LocalShippingOutlinedIcon from "@mui/icons-material/LocalShippingOutlined";
import BuildOutlinedIcon from "@mui/icons-material/BuildOutlined";
import PublicOutlinedIcon from "@mui/icons-material/PublicOutlined";
import ShoppingBagOutlinedIcon from "@mui/icons-material/ShoppingBagOutlined";
import GavelOutlinedIcon from "@mui/icons-material/GavelOutlined";
import NotificationsTitle from "../components/notifications/NotificationsTitle";
import { useNavigate } from "react-router-dom";
import { useRecoilState } from "recoil";
import { notificationsState } from "../atoms/notifications";

const Notifications = () => {
    DynamicTitle("Bildirimler | Hadenka");

    const navigate = useNavigate();
    const [token] = useCookies(["jwt"]);
    const jwt = token.jwt;
    axios.defaults.headers.common["Authorization"] = `Bearer ${jwt}`;

    const [activeTab, setActiveTab] = useState("notifications");
    const [notifications, setNotifications] = useRecoilState(notificationsState);
    const [loading, setLoading] = useState(false);
    const [expandedCards, setExpandedCards] = useState({});
    const [markingRead, setMarkingRead] = useState({});

    // Duyurular - Modal içeriklerinden statik veriler
    const announcements = [
        {
            id: "ebay-entegrasyon",
            title: "eBay Satıcılarına Müjde! 📢",
            icon: <ShoppingBagOutlinedIcon />,
            content: (
                <>
                    <p style={{ fontWeight: 500 }}>Değerli hadenka Üyelerimiz,</p>
                    <p>
                        hadenka'nin ücretsiz eBay entegrasyonu ile artık satış sonrası süreçleriniz zahmetsiz.
                    </p>
                    <p>
                        Tek tıkla tüm siparişlerinizi senkronize edin, kargo süreçlerinizi hızlandırın ve operasyonel yükünüzü hafifletin. 📦
                    </p>
                    <p>
                        Ebay mağazanızı entegre etmenizi bekliyoruz. Bol satışlar dileriz!
                    </p>
                    <p>
                        Entegrasyonla ilgili herhangi bir sorun yaşamanız durumunda, lütfen destek hattımızla iletişime geçmeden hadenka ile olan API bağlantınızı sonlandırmayınız.
                    </p>
                    <p style={{ fontWeight: 500, marginTop: 20 }}>BOL SATIŞLAR! 🚀</p>
                    <p>Hadenka</p>
                </>
            ),
            preview: "hadenka'nin ücretsiz eBay entegrasyonu ile satış sonrası süreçleriniz zahmetsiz...",
        },
        {
            id: "aras-kargo",
            title: "ARAS Kargo Hesap Numarası Değişikliği",
            icon: <LocalShippingOutlinedIcon />,
            content: (
                <>
                    <p>Değerli Kullanıcılarımız,</p>
                    <p>
                        Bizlere ürünlerinizi gönderirken ARAS KARGO'yu kullanıyorsanız hesap numaramız değişmiştir. Yeni hesap numaramız:
                    </p>
                    <div className="announcement-highlight">
                        ARAS KARGO : 93240380115380
                    </div>
                    <p>
                        İlgili ARAS KARGO şubesine lütfen yukarıdaki yeni hesap numarasını vermeyi unutmayınız.
                    </p>
                    <p style={{ fontWeight: 500, marginTop: 20 }}>Hadenka</p>
                </>
            ),
            preview: "ARAS KARGO hesap numaramız değişmiştir...",
        },
        {
            id: "amerika-gumruk",
            title: "Amerika Gümrük Düzenlemeleri Hakkında Önemli Duyuru",
            icon: <PublicOutlinedIcon />,
            content: (
                <>
                    <p style={{ fontWeight: 500 }}>Değerli üyelerimiz,</p>
                    <p>
                        29 Ağustos itibarıyla başlayan yeni Amerika gümrük kuralları çerçevesinde, DDP gönderilen bazı gönderiler için alıcılara ek masraflar yansıtıldığını gözlemlemekteyiz. Yapılan incelemelerde, bu ek masrafların genellikle düşük değer beyanı (ürünün gerçek satış bedelinden daha düşük bir bedelle beyan edilmesi) ve içerik ile GTİP No (HS Code) uyuşmazlığı nedeniyle ortaya çıktığına dair geri bildirimler almaktayız.
                    </p>
                    <p>
                        Bu nedenle, satışını yaptığınız ürünün GTİP No (HS Code) yani Gümrük Tarife Numarasının doğruluğundan ve fatura değeri olarak beyan ettiğiniz tutarın "müşterinizin ödediği toplam bedel" olduğundan emin olmanızı önemle rica ederiz. Bilgilerde hata veya eksiklik olması durumunda, hem alıcıya hem de göndericiye çok yüksek ek maliyetler yansıyabilmektedir.
                    </p>
                    <p>
                        Ayrıca, oluşan bu masraflara itiraz edilmesi halinde "sipariş ekran görüntüsü" ve alıcının ürünü hangi fiyata satın aldığına dair bilgi gümrük yetkilileri tarafından talep edilmektedir. Bu tür bir süreçle karşılaşmamak ve mağduriyet yaşamamak için tüm beyanlarınızın eksiksiz ve doğru olmasına özen göstermeniz büyük önem taşımaktadır.
                    </p>
                </>
            ),
            preview: "29 Ağustos itibarıyla başlayan yeni Amerika gümrük kuralları...",
        },
        {
            id: "amerika-gumruk-detay",
            title: "Amerika Gümrük Düzenlemeleri - Detaylı Bilgi",
            icon: <GavelOutlinedIcon />,
            content: (
                <>
                    <p style={{ fontWeight: 500 }}>Değerli üyelerimiz,</p>
                    <p>
                        29 Ağustos 2025 itibarıyla, tüm dünya ticaretini etkilediği gibi Türkiye'nin sınır ötesi e-ticaretini de ciddi şekilde etkileyecek olan Amerika'nın de minimis değeri (800 USD gümrük muafiyet limiti) konusunda yoğun bir belirsizlik ve endişe yaşandığının farkındayız.
                    </p>
                    <p>
                        Dünya genelinde birçok posta kurumu, geçici olarak Amerika'ya gönderi kabulünü durdurmuştur. Gerek Amerika ofisimiz gerekse sektörün öncü ana taşıyıcıları ile konuyu yakından takip ettiğimizi bilmenizi isteriz.
                    </p>

                    <h4 style={{ color: "var(--btnBgBlue)", margin: "20px 0 10px 0" }}>Amerika'ya gönderilerde neler değişti?</h4>
                    <p><strong>1. 800 USD altı gönderilerde muafiyetin kaldırılması</strong><br />
                        Daha önce 800 USD altındaki ürünler gümrük muafiyetinden faydalanırken, artık bu muafiyet kaldırıldı. Ürün bedeli ne olursa olsun tüm gönderiler gümrüğe tabi olacak ve GTİP numarasına (HS Code) göre belirlenen vergiler alınacaktır.
                    </p>
                    <p><strong>2. %15 ek vergi</strong><br />
                        Amerika gümrükleri, Türkiye'den gelen tüm ürünlere mevcut vergi oranlarına ek olarak %15 ek vergi uygulamaktadır.
                    </p>
                    <p><strong>3. Genel posta gönderilerinde ek masraf</strong><br />
                        Genel posta kapsamında Amerika'ya gönderilen her bir paket için 80 USD ile 200 USD arasında ek masraf alınmaktadır.
                    </p>

                    <h4 style={{ color: "var(--btnBgBlue)", margin: "20px 0 10px 0" }}>Panelimizde Yaptığımız Güncellemeler</h4>
                    <p><strong>1. GTİP no (HS Code) bazlı vergi sorgulama</strong><br />
                        Artık ürünlerinizin gümrük vergisi oranlarını Amerika gümrük vergisi sekmesinden kolayca inceleyebilirsiniz.
                    </p>
                    <p><strong>2. DDP seçeneği</strong><br />
                        Express servislerimizin fiyatlarına DDP (yurtdışı gümrükleme hizmeti) seçeneği eklenmiştir.
                    </p>
                    <p><strong>3. GTİP no (HS Code) alanının zorunlu hale gelmesi</strong><br />
                        Önceden isteğe bağlı olan GTİP no alanı artık zorunludur.
                    </p>

                    <div className="announcement-highlight" style={{ backgroundColor: "#fff3cd", padding: "15px", borderRadius: "8px", margin: "15px 0" }}>
                        <p style={{ margin: "0 0 10px 0", fontWeight: "600" }}>
                            Soru: Express servisleri ile gönderi yaparken DDP seçeneğini seçmeden gönderirsem ne olur?
                        </p>
                        <p style={{ margin: "0" }}>
                            Cevap: Amerika'ya gönderilen her ürün artık gümrüğe tabidir. DDP olmadan yapılan gönderilerde, gümrükleme hizmet bedeli ve vergiler ödenmeden müşterinize teslim edilmeyecektir. Alıcı ödeme yapmazsa gönderi geri dönecek, hem iade masrafları hem de Amerika'da oluşan masraflar size yansıtılacaktır.
                        </p>
                    </div>

                    <p style={{ fontWeight: 500, marginTop: 20 }}>
                        hadenka ekibi olarak USPS servisimizde bazı düzenlemeler gerçekleştirdik. Her şey dahil olarak hazırlanan bu servis sayesinde Amerika gümrükleri için ayrıca bir bakiye ödemenize veya ek maliyet çıkacağı konusunda endişe etmenize gerek kalmayacak.
                    </p>
                </>
            ),
            preview: "800 USD gümrük muafiyet limiti kaldırıldı. Detaylı bilgi için...",
        },
        {
            id: "bakim-duyurusu",
            title: "Planlı Bakım Duyurusu ⚠️",
            icon: <BuildOutlinedIcon />,
            content: (
                <>
                    <p>
                        11.09.2025 tarihinde (çarşambayı perşembeye bağlayan gece) 00:00-02:00 arasında sistemlerimizde planlı bakım çalışması yapılacaktır.
                    </p>
                    <p>
                        Çalışma süresince, web sitemiz ve müşteri panelimizde belli aralıklarla kesintiler öngörülmektedir.
                    </p>
                    <p>Anlayışınız için teşekkür ederiz.</p>
                    <p style={{ fontWeight: 500, marginTop: 20 }}>Saygılarımızla,</p>
                    <p>Hadenka</p>
                </>
            ),
            preview: "Sistemlerimizde planlı bakım çalışması yapılacaktır...",
        },
    ];

    // Bildirimler artık NotificationBar tarafından çekiliyor ve Recoil ile paylaşılıyor
    // Bu sayede her iki bileşen de aynı veriyi kullanıyor

    // Kart genişletme/daraltma
    const toggleCard = (id) => {
        setExpandedCards((prev) => ({
            ...prev,
            [id]: !prev[id],
        }));
    };

    // Bildirimi okundu olarak işaretle
    const handleMarkRead = async (notification) => {
        if (Number(notification?.status) !== 0) return;

        setMarkingRead((prev) => ({ ...prev, [notification.id]: true }));
        try {
            await axios.post(`notification/mark-read/${notification?.id}`);
            setNotifications((prev) =>
                prev.filter((n) => n.id !== notification?.id)
            );
        } catch (error) {
            Errors(error);
        } finally {
            setMarkingRead((prev) => ({ ...prev, [notification.id]: false }));
        }
    };

    // Bildirim tipine göre ikon ve renk
    const getNotificationStyle = (rating) => {
        const ratingNum = Number(rating);
        if (ratingNum < 2) {
            return {
                icon: <CheckCircleOutlineIcon />,
                className: "success",
                label: "Bilgilendirme",
            };
        } else if (ratingNum < 4) {
            return {
                icon: <WarningAmberOutlinedIcon />,
                className: "warning",
                label: "İşlem",
            };
        } else {
            return {
                icon: <ErrorOutlineOutlinedIcon />,
                className: "important",
                label: "Önemli",
            };
        }
    };

    // Okunmamış bildirim sayısı
    const unreadCount = notifications.filter((n) => Number(n.status) === 0).length;

    return (
        <>
            <section className="notifications-page">
                <NotificationBar />
                <NotificationsTitle />
                <div style={WrapperStyle()} className="notifications-wrapper">
                    {/* Content Card with Tabs */}
                    <div className="notifications-content-card">
                        {/* Tabs */}
                        <div className="notifications-tabs">
                            <button
                                className={`notifications-tab-button ${activeTab === "notifications" ? "active" : ""}`}
                                onClick={() => setActiveTab("notifications")}
                            >
                                <NotificationsOutlinedIcon sx={{ fontSize: 20 }} />
                                Bildirimler
                                {unreadCount > 0 && (
                                    <span className="notifications-tab-badge">{unreadCount}</span>
                                )}
                            </button>
                            <button
                                className={`notifications-tab-button ${activeTab === "announcements" ? "active" : ""}`}
                                onClick={() => setActiveTab("announcements")}
                            >
                                <CampaignOutlinedIcon sx={{ fontSize: 20 }} />
                                Duyurular
                            </button>
                        </div>

                        {/* Content */}
                        <div className="notifications-content">
                            {activeTab === "notifications" && (
                                <>
                                    {loading ? (
                                        <div className="notifications-loading">
                                            <CircularProgress sx={{ color: "var(--btnBgBlue)" }} />
                                        </div>
                                    ) : notifications.length > 0 ? (
                                        notifications.map((notification) => {
                                            const style = getNotificationStyle(notification.rating);
                                            const isUnread = Number(notification.status) === 0;
                                            const isExpanded = expandedCards[notification.id];

                                            return (
                                                <div
                                                    key={notification.id}
                                                    className={`notification-card ${isUnread ? "unread" : ""}`}
                                                >
                                                    <div
                                                        className="notification-card-header"
                                                        onClick={() => toggleCard(notification.id)}
                                                    >
                                                        {isUnread && (
                                                            <div className="notification-unread-indicator" />
                                                        )}
                                                        <div className={`notification-icon ${style.className}`}>
                                                            {notification.type === "validation_profile" ||
                                                                notification.type === "validation_bill_address" ? (
                                                                <InfoOutlinedIcon />
                                                            ) : (
                                                                style.icon
                                                            )}
                                                        </div>
                                                        <div className="notification-card-info">
                                                            <h4 className="notification-card-title">
                                                                <span
                                                                    className={`notification-card-type ${style.className}`}
                                                                >
                                                                    {style.label}
                                                                </span>
                                                            </h4>
                                                            <p className="notification-card-preview">
                                                                {notification.text}
                                                            </p>
                                                        </div>
                                                        <ExpandMoreIcon
                                                            className={`notification-expand-icon ${isExpanded ? "expanded" : ""}`}
                                                        />
                                                    </div>

                                                    {isExpanded && (
                                                        <div className="notification-card-body">
                                                            <p>{notification.text}</p>
                                                            <div className="notification-card-actions">
                                                                {isUnread && (
                                                                    <Tooltip title="Okundu olarak işaretle">
                                                                        <Button
                                                                            variant="outlined"
                                                                            size="small"
                                                                            onClick={(e) => {
                                                                                e.stopPropagation();
                                                                                handleMarkRead(notification);
                                                                            }}
                                                                            disabled={markingRead[notification.id]}
                                                                            startIcon={
                                                                                markingRead[notification.id] ? (
                                                                                    <CircularProgress size={16} />
                                                                                ) : (
                                                                                    <RadioButtonUncheckedIcon />
                                                                                )
                                                                            }
                                                                            sx={{
                                                                                borderColor: "var(--btnBgBlue)",
                                                                                color: "var(--btnBgBlue)",
                                                                                textTransform: "none",
                                                                                "&:hover": {
                                                                                    borderColor: "var(--btnBgBlue)",
                                                                                    backgroundColor: "var(--pastelBlue)",
                                                                                },
                                                                            }}
                                                                        >
                                                                            Okundu İşaretle
                                                                        </Button>
                                                                    </Tooltip>
                                                                )}
                                                                {notification.location && (
                                                                    <Button
                                                                        variant="contained"
                                                                        size="small"
                                                                        onClick={(e) => {
                                                                            e.stopPropagation();
                                                                            navigate(`/${notification.location}`);
                                                                        }}
                                                                        sx={{
                                                                            backgroundColor: "var(--btnBgBlue)",
                                                                            textTransform: "none",
                                                                            "&:hover": {
                                                                                backgroundColor: "#1565c0",
                                                                            },
                                                                        }}
                                                                    >
                                                                        Görüntüle
                                                                    </Button>
                                                                )}
                                                            </div>
                                                        </div>
                                                    )}
                                                </div>
                                            );
                                        })
                                    ) : (
                                        <div className="notifications-empty">
                                            <NotificationsOutlinedIcon />
                                            <p>Bildiriminiz bulunmamaktadır.</p>
                                        </div>
                                    )}
                                </>
                            )}

                            {activeTab === "announcements" && (
                                <>
                                    {announcements.map((announcement) => {
                                        const isExpanded = expandedCards[announcement.id];

                                        return (
                                            <div key={announcement.id} className="announcement-card">
                                                <div
                                                    className="announcement-card-header"
                                                    onClick={() => toggleCard(announcement.id)}
                                                >
                                                    <div className="announcement-icon">
                                                        {announcement.icon}
                                                    </div>
                                                    <div className="announcement-card-info">
                                                        <h4 className="announcement-card-title">
                                                            {announcement.title}
                                                        </h4>
                                                        <p className="announcement-card-preview">
                                                            {announcement.preview}
                                                        </p>
                                                    </div>
                                                    <ExpandMoreIcon
                                                        className={`notification-expand-icon ${isExpanded ? "expanded" : ""}`}
                                                    />
                                                </div>

                                                {isExpanded && (
                                                    <div className="announcement-card-body">
                                                        {announcement.content}
                                                    </div>
                                                )}
                                            </div>
                                        );
                                    })}
                                </>
                            )}
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
};

export default Notifications;
